module.exports = __webpack_public_path__ + "static/media/Spot-uvIcon.a5bc3c82.png";